import React from "react"

const SmallInfo = props => {
  return (
    <div className="small-info">
      <div className="small-info__content">
        {props.name !== undefined ? (
          <h4 className="small-info__heading">{props.name}</h4>
        ) : (
          ""
        )}

        {props.secondaryName !== undefined ? (
          <h4 className="small-info__heading--secondary">
            {props.secondaryName}
          </h4>
        ) : (
          ""
        )}
        <p className="small-info__text">{props.value}</p>
      </div>
    </div>
  )
}

export default SmallInfo
